module.exports = __webpack_public_path__ + "static/lundi27-d66a7d67e4bef48f5b41cf7bdbf5f92c.mp4";